<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>入库维护</el-breadcrumb-item>
      <el-breadcrumb-item>入库管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="body02">
      <div class="body02-1">
        <el-card class="card_gundong">
          <el-row :gutter="0">
            <el-row :gutter="0">
              <el-col :span="10">
                <productTypeSelect
                  style="width: 240px"
                  @getProductTypeSelectedUid="getProductTypeSelectedUid"
                  ref="productTypeSelect"
                  :chanpin_type="productTypeSelect"
                  :key="this.datekey"
                >
                </productTypeSelect>
              </el-col>

              <el-col :span="10">
                <el-input
                  placeholder="请输入查询内容"
                  v-model="queryInfo.query"
                  class="input-with-select"
                  clearable
                  style="width: 300px"
                  @clear="getproductList"
                  @change="getproductList"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getproductList"
                  ></el-button>
                </el-input>
              </el-col>
            </el-row>
          </el-row>
          <el-row :gutter="0" class="el_row_two">
            <el-col :span="24" id="report">
              <el-table :data="productList" style="width: 100%" class="font_xiao" border stripe>
                <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
                <!-- <el-table-column prop="uid" label="序号" width="60"></el-table-column> -->
                <el-table-column type="expand" v-if="productList.proType04Code === 9005">
                  <template slot-scope="scope">
                    <el-table :data="scope.row.zuheProductlist" stripe>
                      <el-table-column type="index" label="序号" width="80"></el-table-column>
                      <el-table-column prop="pro_uid" label="商品序号" width="200">
                      </el-table-column>
                      <el-table-column prop="pro_name" label="商品名称" width="200">
                      </el-table-column>
                      <el-table-column label="商品类别" width="300">
                        <template slot-scope="scope"
                          >{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                            scope.row.leixing03
                          }}:{{ scope.row.leixing04 }}</template
                        >
                      </el-table-column>
                      <el-table-column prop="pro_count" label="商品数量" show-overflow-tooltip>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column prop="pro_bianhao" label=" 编号" width="130"></el-table-column>
                <el-table-column
                  prop="pro_name"
                  label="名称"
                  max-width="180"
                  width="180"
                  style="width: 50px"
                ></el-table-column>
                <el-table-column
                  label="成本价"
                  prop="pro_price_chengben"
                  max-width="100"
                  width="60"
                >
                </el-table-column>

                <!-- <el-table-column label="类型" width="300">
                                    <template v-slot="scope">
                                        {{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{ scope.row.leixing03 }}:{{
                                            scope.row.leixing04 }}
                                    </template>
                                </el-table-column> -->
                <!-- <el-table-column prop="pro_xinghao" label="型号" width="120"></el-table-column> -->
                <!-- <el-table-column prop="pro_price_gaoji" label="产地" width="80"></el-table-column> -->
                <!-- <el-table-column prop="add_time" label="加入时间" width="190"></el-table-column> -->
                <el-table-column label="操作">
                  <template v-slot="scope">
                    <el-input
                      placeholder="入库价格"
                      v-model="scope.row.pro_price_chengben"
                      class="input-with-select"
                      clearable
                      style="width: 80px"
                    >
                    </el-input>
                    <el-input
                      placeholder="库位"
                      v-model="scope.row.pro_kuwei"
                      class="input-with-select"
                      clearable
                      style="width: 80px"
                    >
                    </el-input>
                    <el-input-number
                      v-model="scope.row.count"
                      :min="1"
                      :max="1000"
                      style="width: 130px"
                      label="0.0"
                    ></el-input-number>
                    <el-button
                      @click="
                        kucun_ruku_add(
                          scope.row.uid,
                          scope.row.pro_bianhao,
                          scope.row.pro_name,
                          scope.row.pro_type,
                          scope.row.pro_price_chengben,
                          scope.row.leixing01,
                          scope.row.leixing02,
                          scope.row.leixing03,
                          scope.row.leixing04,
                          scope.row.count,
                          scope.row.proType04Code,
                          scope.row.zuheProductlist,
                          scope.row.pro_kuwei
                        )
                      "
                      type="primary"
                      plain
                      style="margin-left: 20px"
                      >添加</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.pageNum"
            :page-sizes="[10, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
            <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
          </el-pagination>
        </el-card>
      </div>
      <div class="body02-2">
        <el-card class="card_gundong002">
          
            <span style="background-color: #ddd; width: 100%; padding-bottom: 10px">
              入库单编号：{{ rukudan_bianhao }}
            </span>
            <el-table
              ref="multipleTable"
              :data="kucunAddData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              class="font_xiao"
              :default-sort="{ prop: 'xuhao', order: 'descending' }"
            >
              <el-table-column   label="序号"  width="50">
                <template slot-scope="scope">{{ scope.$index }}</template>
              </el-table-column>
              <el-table-column prop="proUid" label="商品序号"  width="70"> </el-table-column>
              <el-table-column prop="proName" label="名称"> </el-table-column>
              <el-table-column label="类别">
                <template slot-scope="scope"
                  >{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{ scope.row.leixing03 }}:{{
                    scope.row.leixing04
                  }}</template
                >
              </el-table-column>
              <el-table-column prop="proPrice" label="价格" width="50" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="proCount" label="数量"  width="50" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="proKuwei" label="库位"   width="50">  </el-table-column>
              <el-table-column label="操作" show-overflow-tooltip width="50">
                <template slot-scope="scope2">
                  <el-button
                    @click="ruku_delete(scope2.$index, kucunAddData)"
                    style="font-size: 22px"
                    v-if="scope2.row.delFlag === 1"
                    type="text"
                    icon="el-icon-remove-outline"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
         
          <div style="margin-top: 20px; text-align: center" v-if="caozuo_type !== '1'">
            <el-button type="primary" @click="rukuAdd">确定入库</el-button>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import productTypeSelect from '../../tongyong/productType_select.vue'
import { checkMobileTest, checkSfzId } from '../config/validator'
export default {
  props: ['caozuo_type', 'mendianUid', 'productTypeSelect'], // caozuo_type 操作类型 1  直接操作  2 调用操作 productTypeSelect 类型选择参数
  components: {
    productTypeSelect: productTypeSelect
  },
  data() {
    return {
      rukudan_bianhao: '',
      datekey: Date.now(),
      kucunAddData: [],
      kucunAddData_proUid: [],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list_more',
        C_table_name: 'product_list04', // 04 为读取有库存的所有商品
        query: '',
        pageNum: 1,
        pageSize: 10,
        CI_canshu01: this.mendianUid,
        CI_canshu03: 1
      },
      productList: [],
      //  recordCount: 0,
      total: 0,
      addForm: {
        C_type: 'product_add',
        pro_bianhao: '',
        pro_xinghao: '',
        pro_price_shichang: 0,
        pro_price_huiyuan: 0,
        pro_price_pifa: 0,
        pro_price_gaoji: 0,
        pro_name: '',
        pro_chandi: '',
        pro_xilie: '',
        pro_type: '',
        pro_level: 1,
        pro_memo: ''
      },

      // 表单规则项
      addFormRules: {
        pro_name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
        ]
      },

      editFormRules: {}
    }
  },
  created() {
    this.getproductList()
    this.rukudan_bianhao_get()
  },
  methods: {
    getProductTypeSelectedUid(val) {
      // this.data.proTypeUid = val.productTypeSelectedUid
      this.proTypeUid = val.productTypeSelectedUid
      this.queryInfo.CI_canshu02 = this.proTypeUid
      this.getproductList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    kucun_ruku_add(
      proUid,
      proBianhao,
      proName,
      proType,
      proPrice,
      leixing01,
      leixing02,
      leixing03,
      leixing04,
      proCount,
      proType04Code,
      zuheProductlist,
      proKuwei
    ) {
      // 分析商品uid 重复的 直接累加
      // 借助 kucunAddData_proUid 找到下标
      console.log('proPrice', proPrice === '')
      if (proPrice === undefined || proPrice === 0.0 || proPrice === '') {
        this.$message('请填写入库价格！')
        return
      }
      if (proKuwei === undefined || proKuwei === '') {
        this.$message('请填写入库位！')
        return
      }
      var xiabiao = this.kucunAddData_proUid.indexOf(proUid) // 找到下标返回下标，没有找到返回-1
      this.getproductList()
      if (xiabiao !== -1) {
        this.kucunAddData[xiabiao].proCount += proCount
        this.kucunAddData[xiabiao].proPrice = proPrice
        // 处理附赠商品的数据，也要同时增加数量
        if (proType04Code === 9005) {
          const obj = zuheProductlist
          obj.forEach((item, index) => {
            var xiabiao2 = this.kucunAddData_proUid.indexOf(item.uid)
            console.log('xiabiao2', this.kucunAddData_proUid, xiabiao2, item.uid)
            if (xiabiao2 !== -1) {
              // 附赠商品，要根据组合的单品数量计算所需数量
              this.kucunAddData[xiabiao2].proCount += proCount * item.pro_count
            }
            // 不能删除
          })
        }
        return
      }
      var dataAdd = {
        proUid: proUid,
        proBianhao: proBianhao,
        proName: proName,
        proType: proType,
        proPrice: proPrice,
        leixing01: leixing01,
        leixing02: leixing02,
        leixing03: leixing03,
        leixing04: leixing04,
        proCount: proCount,
        proType04Code: proType04Code, // proTypeCode 用来标识类别是否是组合商品，添加商品时可以进行处理 ,不用proType 这个是防止，数据重新导入的时候，该uid会变化
        delFlag: 1, // 列表框是否可以删除标记，只有 主商品可以删除，主商品删除，附赠商品一起删除
        zuheProductlist: zuheProductlist, // 压入数组，方便删除时候用
        proKuwei: proKuwei
      }
      console.log(999111, dataAdd)
      this.kucunAddData.push(dataAdd)
      this.kucunAddData_proUid.push(proUid)
      console.log(9005, proType04Code)
      if (proType04Code === 9005) {
        const obj = zuheProductlist
        obj.forEach((item, index) => {
          console.log(item)
          dataAdd = {
            proUid: item.uid,
            proBianhao: item.proBianhao,
            proName: item.pro_name,
            proType: item.proType,
            proPrice: proPrice,
            leixing01: item.leixing01,
            leixing02: item.leixing02,
            leixing03: item.leixing03,
            leixing04: item.leixing04,
            proCount: proCount * item.pro_count,
            proTypeCode: item.proTypeCode, // proTypeCode 用来标识类别是否是组合商品，添加商品时可以进行处理 ,不用proType 这个是防止，数据重新导入的时候，该uid会变化
            delFlag: 0
          }
          this.kucunAddData.push(dataAdd)
          this.kucunAddData_proUid.push(item.uid)
        })
      }
      console.log(911, this.kucunAddData)
    },
    ruku_count_input() {},
    async rukudan_bianhao_get(proUid, proCount) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 17 }
      })

      this.rukudan_bianhao = JSON.parse(res.data)[0].bianhao_l
    },
    async getproductList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      })
      // console.log(9980, JSON.parse(res.data)[0].dataList)

      if (!JSON.parse(res.data)[0].dataList) return
      this.productList = JSON.parse(res.data)[0].dataList
      console.log(880, this.productList)
      this.productList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1
      })

      this.total = JSON.parse(res.data)[0].total

      // console.log(this.total)
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getproductList()
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getproductList()
    },

    async rukuAdd() {
      if (this.kucunAddData.length === 0) {
        this.$message.error('请录入商品及数量后再行递交！')
        return 0
      }
      const comfirmResult = await this.$confirm('确定商品入库, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      console.log(comfirmResult)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消')

      var rukuData = {
        C_type: 'kucun_rukudan_add',
        count: this.kucunAddData.length,
        rukudan_bianhao: this.rukudan_bianhao,
        mendianUid: this.mendianUid
      }
      const { data: res } = await this.$http.post('api', rukuData)
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('添加失败')
        return
      }
      var rukudanUid = JSON.parse(res.data)[0].rukudan_uid
      const obj = this.kucunAddData
      console.log(obj)
      obj.forEach((item, index) => {
        console.log(item)
        const data = {
          C_type: 'kucun_ruku_add',
          pro_uid: item.proUid,
          pro_count: item.proCount,
          pro_price: item.proPrice,
          rukudanUid: rukudanUid,
          mendianUid: this.mendianUid,
          proKuwei: item.proKuwei
        }
        const { data: res02 } = this.$http.post('api', data)
      })
      this.$message.success('入库成功')
      this.input_init()
      if (this.caozuo_type === 1) this.$emit('closeRuku', 1)
    },
    input_init() {
      this.getproductList()
      this.kucunAddData = []
      this.kucunAddData_proUid = []
      this.rukudan_bianhao_get()
    },
    async productInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'product_info', uid: uid, C_type: 'get_info' }
      })
      // console.log(JSON.parse(res.data))
      console.log(res.data)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败')
      }

      this.editForm = JSON.parse(res.data)[0].data[0]
      console.log(700, this.editForm)
      // this.huifangForm.huifang_product_uid = JSON.parse(res.data)[0].data[0].uid;
    },

    async ruku_delete(index, rows) {
      console.log(803, index, rows)
      const comfirmResult = await this.$confirm('确定删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')
      // 要先删除附赠商品
      if (rows[index].proType04Code === 9005) {
        const obj = rows[index].zuheProductlist
        obj.forEach((item, index2) => {
          var xiabiao2 = this.kucunAddData_proUid.indexOf(item.uid)
          console.log('xiabiao2', this.kucunAddData_proUid, item.uid, xiabiao2)
          if (xiabiao2 !== -1) {
            rows.splice(xiabiao2, 1)
            this.kucunAddData_proUid.splice(xiabiao2, 1)
          }
          // 不能删除
        })
      }
      // 再行删除本体
      rows.splice(index, 1)
      this.kucunAddData_proUid.splice(index, 1)
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}

.card_gundong {
  height: 600px;
  overflow-y: auto;
}

.font_xiao {
  font-size: 12px;
}

.card_gundong002 {
  height: 500px;
  overflow-y: auto;
}

.body02 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.body02-1 {
  width: 55%;
}

.body02-2 {
  width: 45%;
}
</style>
